document.addEventListener('DOMContentLoaded', function() {
    // Check if the current page is the "pages/services" page
    if (window.location.pathname === '/pages/services') {
        // Function to handle scrolling
        function scrollToSection(event) {
            event.preventDefault(); // Prevent default anchor behavior
            var targetId = this.getAttribute('href'); // Get target section id
            var targetSection = document.querySelector(targetId); // Find target section element
            if (targetSection) {
                var scrollOffset = targetSection.offsetTop - 150; // Adjust this value to determine how far above to scroll
                // Check if the smooth scrolling behavior is supported
                if ('scrollBehavior' in document.documentElement.style) {
                    // Smooth scroll if supported
                    window.scrollTo({ top: scrollOffset, behavior: 'smooth' });
                } else {
                    // Otherwise, jump to the target section
                    window.scrollTo(0, scrollOffset);
                }
            }
        }

        // Find all link elements for each service
        var nailLink = document.querySelector('.grid-item:nth-child(2) a');
        var faceLink = document.querySelector('.grid-item:nth-child(3) a');
        var bodyLink = document.querySelector('.grid-item:nth-child(4) a');
        var hairLink = document.querySelector('.grid-item:nth-child(1) a');

        // Replace the href attribute value for each service
        nailLink.setAttribute('href', '#nail-section');
        faceLink.setAttribute('href', '#face-section');
        bodyLink.setAttribute('href', '#body-section');
        hairLink.setAttribute('href', '#hair-section');

        // Attach click event listener to each link
        [nailLink, faceLink, bodyLink, hairLink].forEach(function(link) {
            link.addEventListener('click', scrollToSection);
        });
    }
});
